import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M16.59 5C16.713 5.121 16.858 5.261 17.015 5.414C17.633 6.016 18.514 6.874 19 7.387V18C19 18.551 18.551 19 18 19H6C5.449 19 5 18.551 5 18V6C5 5.449 5.449 5 6 5H16.59ZM17 4H6C4.9 4 4 4.9 4 6V18C4 19.1 4.9 20 6 20H18C19.1 20 20 19.1 20 18V7C19.457 6.366 17.507 4.51 17 4Z"
      fill="currentColor"
    />
    <path
      d="M16.0051 14.05V19H7.96411V14.05H16.0051ZM16.0051 13.05H7.96411C7.41411 13.05 6.96411 13.5 6.96411 14.05V19C6.96411 19.55 7.41411 20 7.96411 20H16.0051C16.5551 20 17.0051 19.55 17.0051 19V14.05C17.0051 13.5 16.5551 13.05 16.0051 13.05Z"
      fill="currentColor"
    />
    <path
      d="M14.0141 5V8.046H9.95508V5H14.0141V5ZM14.0141 4H9.95508C9.40508 4 8.95508 4.45 8.95508 5V8.046C8.95508 8.596 9.40508 9.046 9.95508 9.046H14.0141C14.5641 9.046 15.0141 8.596 15.0141 8.046V5C15.0141 4.45 14.5641 4 14.0141 4V4Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Save');

export default Icon;
